export default "__VITE_ASSET__h9RrEnXu__"